export default {"src":"/_next/static/media/Arrow-up.7d1ed747.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};